let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3ck1H")).then(() => parcelRequire('2qMIc'));